module.exports = __webpack_public_path__ + "static/media/AppliedDiff_Q7.cf74cd1b.svg";